const strapiBaseUrl = process.env.REACT_APP_STRAPI_URL?.replace(/\/$/, "");

function normalizeEntity(entity) {
  if (!entity || typeof entity !== "object") {
    return entity;
  }

  if ("attributes" in entity && entity.attributes && typeof entity.attributes === "object") {
    return { id: entity.id, ...entity.attributes };
  }

  return entity;
}

function unwrapMedia(media) {
  if (!media || typeof media !== "object") {
    return null;
  }

  if ("data" in media) {
    return normalizeEntity(media.data);
  }

  return normalizeEntity(media);
}

export function getStrapiMediaUrl(media) {
  const normalizedMedia = unwrapMedia(media);
  const rawUrl =
    normalizedMedia?.url ||
    normalizedMedia?.formats?.large?.url ||
    normalizedMedia?.formats?.medium?.url ||
    normalizedMedia?.formats?.small?.url ||
    normalizedMedia?.formats?.thumbnail?.url;

  if (!rawUrl) {
    return "";
  }

  if (/^https?:\/\//i.test(rawUrl)) {
    return rawUrl;
  }

  return strapiBaseUrl ? `${strapiBaseUrl}${rawUrl}` : rawUrl;
}

export async function fetchStrapiCollection(pathname) {
  if (!strapiBaseUrl) {
    return null;
  }

  const allItems = [];
  let currentPage = 1;
  let pageCount = 1;

  while (currentPage <= pageCount) {
    const separator = pathname.includes("?") ? "&" : "?";
    const pagedPath = `${pathname}${separator}pagination[page]=${currentPage}`;
    const response = await fetch(`${strapiBaseUrl}${pagedPath}`);

    if (!response.ok) {
      throw new Error(`Strapi request failed with status ${response.status}`);
    }

    const payload = await response.json();

    if (!Array.isArray(payload?.data)) {
      return [];
    }

    allItems.push(...payload.data.map(normalizeEntity));
    pageCount = payload?.meta?.pagination?.pageCount || 1;
    currentPage += 1;
  }

  return allItems;
}

export async function fetchStrapiSingle(pathname) {
  if (!strapiBaseUrl) {
    return null;
  }

  const response = await fetch(`${strapiBaseUrl}${pathname}`);

  if (!response.ok) {
    throw new Error(`Strapi request failed with status ${response.status}`);
  }

  const payload = await response.json();

  if (!payload?.data) {
    return null;
  }

  return normalizeEntity(payload.data);
}

export function hasStrapiConfig() {
  return Boolean(strapiBaseUrl);
}
